/**
 * @param selector {string}
 * @param onUpdated {(formField: HTMLElement) => void}
 * @return {void}
 */
module.exports = function listenToFirstFormFieldUpdate(selector, onUpdated) {
    document.querySelectorAll(selector).forEach(formField => {
        if (formField instanceof HTMLElement) {
            const listener = e => {
                onUpdated(e.currentTarget);
                formField.removeEventListener("change", listener);
            };

            formField.addEventListener("change", listener);
        }
    });
}